import * as React from "react";
import { useSelector } from "react-redux";
import Button from "../Button/Button";
import { getUserProfile } from "../../store/user/selectors";
import "./UserModule.css";
import MediaQuery from "react-responsive";
import { MOBILE_MAX_WIDTH } from "../../utils";

const UserModule: React.FC = (props) => {
	const userProfile = useSelector(getUserProfile);

	const loginPage = () => {
		window.location.href = "/login";
	};

	const goToProfile = () => {
		window.location.href = `/user/${userProfile.id}`;
	};

	return (
		<div className="header__right">
			{!userProfile ? (
				<Button type="primary" onClick={loginPage}>
					Войти
				</Button>
			) : (
				<div className="header__user" onClick={goToProfile}>
					<MediaQuery minWidth={MOBILE_MAX_WIDTH}>
						<div>{userProfile.name}</div>
					</MediaQuery>

					<img src={userProfile.imageURL} />
				</div>
			)}
		</div>
	);
};

export default UserModule;
